import { styled } from '../../../theme/styled';
import { AudioPlayerOwnerState } from '../model';

export const AudioPlayerRoot = styled('div', {
  name: 'AudioPlayer',
  slot: 'Root',
})<{ ownerState: AudioPlayerOwnerState }>(({ theme, ownerState }) => {
  const { size } = ownerState;
  return {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette['white'],
    borderRadius: `${theme.borderRadius.medium}px`,
    paddingTop: 10.5,
    paddingBottom: 10.5,
    paddingLeft: { normal: 20, small: 13 }[size],
    paddingRight: { normal: 20, small: 12 }[size],
  };
});
